import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <AuthLayout eyebrow="Check your inbox" title="Reset link sent" subtitle="If an account exists for this email, you'll receive a reset link within a minute.">
        <div className="flex items-center gap-3 p-4 rounded-xl bg-[#22C55E]/8 border border-[#22C55E]/20 text-[#166534]">
          <MailCheck className="w-5 h-5" /> <span className="text-[15px]">Sent to <b>{email}</b>.</span>
        </div>
        <Link to="/login" className="mt-6 lux-btn-secondary w-full flex items-center justify-center">Back to sign in</Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout eyebrow="Forgot password" title="Reset your password" subtitle="Enter your email and we'll send you a secure link to reset it.">
      <form onSubmit={onSubmit} className="space-y-5">
        <div>
          <label className="lux-label">Work email</label>
          <input
            data-testid="forgot-email-input"
            className="lux-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
          />
        </div>
        {error && (
          <div data-testid="forgot-error" className="text-[15px] text-[#EF4444] bg-[#EF4444]/8 border border-[#EF4444]/20 rounded-xl px-4 py-3">{error}</div>
        )}
        <button data-testid="forgot-submit-btn" className="lux-btn-primary w-full flex items-center justify-center" disabled={loading}>
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
        </button>
        <p className="text-center text-[15px] text-nexa-mute pt-2">
          Remembered it?{" "}
          <Link data-testid="forgot-login-link" to="/login" className="lux-link">Back to sign in</Link>
        </p>
      </form>
    </AuthLayout>
  );
}
